var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurplePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0C7.6262 0 0 7.4019 0 16.5C0 25.5981 7.6262 33 17 33C26.3738 33 34 25.5981 34 16.5C34 7.4019 26.3738 0 17 0ZM13.6 22.2156V10.7844L23.8 16.5L13.6 22.2156Z",
    fill: "#8C4799"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplePlay);
export default __webpack_public_path__ + "static/media/purple_play.f0f4482f0ec6d6d150614630ac9134ab.svg";
export { ForwardRef as ReactComponent };